
function selectText(element) {
	if (document.body.createTextRange) { // ms
		var range = document.body.createTextRange();
		range.moveToElementText(element);
		range.select();
	} else if (window.getSelection) { // moz, opera, webkit
		var selection = window.getSelection();            
		var range = document.createRange();
		range.selectNodeContents(element);
		selection.removeAllRanges();
		selection.addRange(range);
	}
}

var company = {
	name: 'Plastic Resource'
	,tel: '651-702-9243'
	,telTollFree: '833-290-5684'
	,website: {
			url: 'https://www.plasticresource.com/'
		,text: 'www.plasticresource.com'
	}
};

function generateSig( person ){
	var hasExt = person.phone !== company.tel;
	var colors = {
			general: '#2e2f34'
			,link: '#475181'
			,company: '#252b49'
	}
	var aStyle = 'color: '+colors.link+'; font-weight:bold; text-decoration: none;';
	var bStyle = 'color: '+colors.company+';font-weight:bold;';
	
	var r = '<div>'
	+'<table border="0" cellspacing="0" cellpadding="0" style="color: '+colors.general+';" bgcolor="white"	>'
	+'	<tr>'
	+'		<td width="150" valign="top">'
	+'			<img style="margin:0;" border="0" src="https://www.plasticresource.com/assets/images/email-signature/signature_logo.jpg" />'
	+'		</td>'
	+'		<td valign="top">'
	+'			<table border="0" cellspacing="0" cellpadding="0" style="font-family: Arial, Helvetica, sans-serif; font-size: 12px;">'
	+'				<tr><td height="60"><img src="https://www.plasticresource.com/assets/images/email-signature/signature_line.jpg" /></td></tr>'
	+'				<tr><td valign="bottom" style="font-size: 24px; font-family: georgia, times, serif;padding-left: 15px;">'+person.name+'</td></tr>'
	+'				<tr>'
	+'					<td style="padding-left: 15px; padding-top: 3px">'
	+'<span style="'+bStyle+'">Direct: </span><span style="white-space: nowrap;"><a href="tel: '+person.phone+'" style="'+aStyle+'">'+person.phone+'</a></span>'
	+'					</td>'
	+'				</tr>'
	+'				<tr>'
	+'					<td style="padding-left: 15px; padding-top: 3px">'
	+'<span style="'+bStyle+'">Toll Free: </span><span style="white-space: nowrap;"><a href="tel: '+company.telTollFree+'" style="'+aStyle+'">'+company.telTollFree+'</a><span></span>'
	+'					</td>'
	+'				</tr>'
	+'				<tr>'
	+'					<td style="padding-left: 15px; padding-top: 3px">'
	+'<a href="'+company.website.url+'" style="'+aStyle+'">'+company.website.text+'</a>'
	+'					</td>'
	+'				</tr>'
	+'			</table>'
	+'		</td>'
	+'	</tr>'
	+'</table></div>';
	return r;
};
	

function init() {
	var generateButton = document.getElementById("emailSignatureGenerator__button");
	var previewContainer = document.getElementById("emailSignatureGenerator__previewContainer");
	var emailSignatureGenerator__preview = document.getElementById("emailSignatureGenerator__preview");
	var emailSignatureGenerator__copy = document.getElementById("emailSignatureGenerator__copy");

	if (previewContainer === null || generateButton === null || emailSignatureGenerator__preview === null || emailSignatureGenerator__copy === null) {
		return;
	}
	generateButton.addEventListener("click", function(event) {
		event.preventDefault();
		var person = {
			name: document.getElementById("generateSigForm__name").value,
			phone: document.getElementById("generateSigForm__phone").value
		}
		emailSignatureGenerator__preview.innerHTML = generateSig(person);
		previewContainer.classList.add("hasValue");
		return false; // Stop form from submitting.
	}, false);

	emailSignatureGenerator__copy.addEventListener("click", function() {
		selectText( emailSignatureGenerator__preview.get(0) )
	}, false);
}

module.exports = {
	init : init
};


